// CopyVymeraModal.jsx — Kopírovať výmeru DO bytu (aj medzi objektami) + krok späť
// Mirko 2026-06-04, ústava 1212 (Z→Na + Skopírovať) + 12.0.3 (potvrdenie). NAHRADIŤ prepisuje ostré dáta.
import React, { useState } from 'react'

const num = x => { const v = parseFloat(String(x).replace(',', '.')); return isFinite(v) ? v : 0 }
const f = x => (Math.round((x || 0) * 100) / 100).toFixed(2).replace('.', ',')
const calcRoom = (rm, vyska, hlbka) => {
  const bm = (rm.vals || []).reduce((a, x) => a + num(x), 0)
  const hl = (hlbka || 150) / 1000; let dv = 0, ok = 0, spa = 0
  ;(rm.otvory || []).forEach(o => {
    const sM = num(o.s) / 100, vM = num(o.v) / 100, ks = num(o.ks) || 1
    const plo = sM * vM * ks; if (o.typ === 'okno') ok += plo; else dv += plo
    let sp = 0; if (o.L) sp += vM * hl; if (o.P) sp += vM * hl; if (o.H) sp += sM * hl; if (o.D) sp += sM * hl; spa += sp * ks
  })
  const strop = num(rm.strop), ne = num(rm.ne)
  const steny = Math.max(0, bm * num(vyska) - dv - ok + spa - ne)
  return { strop, steny, spolu: steny + strop }
}
const bSum = b => { let t = { strop: 0, steny: 0, spolu: 0 }; (b.rooms || []).forEach(rm => { const c = calcRoom(rm, b.vyska, b.hlbka); t.strop += c.strop; t.steny += c.steny; t.spolu += c.spolu }); return t }
const serializeRooms = rooms => (rooms || []).map(rm => ({
  n: rm.n, partak: rm.partak || '', vals: (rm.vals || []).map(num).filter(x => x > 0),
  strop: num(rm.strop), ne: num(rm.ne),
  otvory: (rm.otvory || []).map(o => ({ typ: o.typ, s: num(o.s) / 100, v: num(o.v) / 100, ks: num(o.ks) || 1, L: !!o.L, P: !!o.P, H: !!o.H, D: !!o.D }))
}))
const newUid = () => 'd' + Date.now().toString(36) + Math.random().toString(36).slice(2, 8)

export default function CopyVymeraModal({ src, byty, projectId, onClose, onDone }) {
  const [mode, setMode] = useState('exist')         // 'exist' | 'new'
  const targets = (byty || []).filter(b => b.id && b.id !== src.id)
  const [tgtId, setTgtId] = useState(targets[0] ? targets[0].id : '')
  const [nObj, setNObj] = useState(src.obj || '')
  const [nPo, setNPo] = useState(src.po || '')
  const [nByt, setNByt] = useState('')
  const [confirmTxt, setConfirmTxt] = useState('')
  const [busy, setBusy] = useState(false)
  const [done, setDone] = useState(null)            // { prev } po nahradení (undo)

  const token = () => localStorage.getItem('kamir_token') || ''
  const H = () => ({ 'Content-Type': 'application/json', Authorization: `Bearer ${token()}` })
  const objekty = [...new Set((byty || []).map(b => b.obj || '').filter(Boolean))]
  const poschodia = [...new Set((byty || []).filter(b => (b.obj || '') === nObj).map(b => b.po || '').filter(Boolean))]
  const srcT = bSum(src)
  const tgt = byty.find(b => b.id === tgtId)
  const ready = mode === 'exist' ? (confirmTxt.trim().toUpperCase() === 'NAHRADIT') : (!!nObj && !!nByt.trim())

  const payloadFrom = (identity) => {
    const t = bSum(src)
    return {
      client_uid: identity.client_uid || newUid(), project_id: projectId, zakazka: identity.zak || (src.zak || ''),
      partak: identity.partak || '', obj: identity.obj, po: identity.po, byt: identity.byt, typ: identity.typ || 'byt',
      vyska: num(src.vyska), hlbka: src.hlbka, rooms: serializeRooms(src.rooms),
      spolu: t.spolu, strop: t.strop, steny: t.steny
    }
  }

  const doReplace = async () => {
    if (!ready || !tgt) return
    if (tgt.completed_at) { alert('Cieľový byt je UZAMKNUTÝ. Najprv ho odomkni (Admin PIN), potom nahraď.'); return }
    setBusy(true)
    try {
      const prev = JSON.parse(JSON.stringify(tgt))      // snapshot pre krok späť (display formát)
      const body = payloadFrom(tgt)   // parťák CIEĽA ostáva (NEkopíruje sa — každý byt môže robiť niekto iný)
      const r = await fetch('/api/vymery/' + tgt.id, { method: 'PUT', headers: H(), body: JSON.stringify(body) })
      if (!r.ok) throw new Error('PUT ' + r.status)
      setBusy(false); setDone({ prev }); if (onDone) await onDone()
    } catch (e) { setBusy(false); alert('Chyba pri nahradzovaní: ' + e.message) }
  }
  const doNew = async () => {
    if (!ready) return
    if (byty.some(b => (b.obj || '') === nObj && (b.po || '') === nPo && (b.byt || '').trim() === nByt.trim()))
      { alert('Byt ' + nObj + ' · ' + nPo + ' · ' + nByt + ' už existuje — vyber „Existujúci byt" a NAHRADIŤ.'); return }
    setBusy(true)
    try {
      const body = payloadFrom({ obj: nObj, po: nPo, byt: nByt.trim(), zak: src.zak, typ: 'byt' })   // parťák NEkopírujem (prázdny, priradí sa ručne)
      const r = await fetch('/api/vymery', { method: 'POST', headers: H(), body: JSON.stringify(body) })
      if (!r.ok) throw new Error('POST ' + r.status)
      setBusy(false); if (onDone) await onDone(); onClose()
    } catch (e) { setBusy(false); alert('Chyba pri vytváraní: ' + e.message) }
  }
  const doUndo = async () => {
    const p = done.prev; setBusy(true)
    try {
      const t = bSum(p)
      const body = { client_uid: p.client_uid || newUid(), project_id: projectId, zakazka: p.zak, partak: p.partak || '', obj: p.obj, po: p.po, byt: p.byt, typ: p.typ || 'byt', vyska: num(p.vyska), hlbka: p.hlbka, rooms: serializeRooms(p.rooms), spolu: t.spolu, strop: t.strop, steny: t.steny }
      const r = await fetch('/api/vymery/' + p.id, { method: 'PUT', headers: H(), body: JSON.stringify(body) })
      if (!r.ok) throw new Error('PUT ' + r.status)
      setBusy(false); if (onDone) await onDone(); onClose()
    } catch (e) { setBusy(false); alert('Krok späť zlyhal: ' + e.message) }
  }

  // ── štýly ──
  const ov = { position: 'fixed', inset: 0, background: 'rgba(20,28,42,.4)', display: 'flex', justifyContent: 'center', alignItems: 'flex-start', padding: '40px 14px', zIndex: 1000 }
  const mod = { width: 580, maxWidth: '100%', background: '#fff', borderRadius: 14, boxShadow: '0 18px 50px rgba(0,0,0,.3)', overflow: 'hidden', fontFamily: 'inherit' }
  const head = { padding: '14px 18px', background: '#15171A', color: '#fff', fontWeight: 800, fontSize: 15 }
  const body = { padding: 18, maxHeight: '74vh', overflow: 'auto' }
  const srcBox = { background: 'rgba(2,132,199,.1)', border: '1px solid rgba(2,132,199,.3)', borderRadius: 10, padding: '11px 14px', marginBottom: 16 }
  const lab = { fontSize: 11, fontWeight: 800, letterSpacing: '.04em', textTransform: 'uppercase', color: '#5b6573', margin: '6px 0 8px' }
  const inp = { padding: '7px 9px', border: '1px solid #d6dde6', borderRadius: 7, fontSize: 13, fontFamily: 'inherit' }
  const panel = { border: '1px dashed #d6dde6', borderRadius: 10, padding: 13, marginBottom: 14, background: '#fafbfd' }
  const warn = { border: '2px solid #dc2626', background: '#fff5f5', borderRadius: 11, padding: 14 }
  const cin = { width: '100%', padding: 10, border: '2px solid #dc2626', borderRadius: 8, fontSize: 15, fontWeight: 800, letterSpacing: '.18em', textAlign: 'center', textTransform: 'uppercase', fontFamily: 'inherit', marginTop: 6, boxSizing: 'border-box' }
  const btn = (bg, col, on = true) => ({ padding: '9px 16px', border: 'none', borderRadius: 8, background: bg, color: col, fontWeight: 800, fontSize: 13, cursor: on ? 'pointer' : 'default', fontFamily: 'inherit', opacity: on ? 1 : .45, pointerEvents: on ? 'auto' : 'none' })
  const ghost = { padding: '9px 16px', border: '1px solid #d6dde6', borderRadius: 8, background: '#fff', color: '#5b6573', fontWeight: 700, fontSize: 13, cursor: 'pointer', fontFamily: 'inherit' }
  const lnk = { fontSize: 12, color: '#0369a1', fontWeight: 700, textDecoration: 'none', cursor: 'pointer' }

  // PO NAHRADENÍ — krok späť
  if (done) return (
    <div style={ov} onClick={onClose}><div style={mod} onClick={e => e.stopPropagation()}>
      <div style={{ ...head, background: '#41694C' }}>Výmera nahradená</div>
      <div style={body}>
        <div style={{ fontSize: 14, marginBottom: 14 }}>Byt <b>{done.prev.obj} · {done.prev.po} · {done.prev.byt}</b> má teraz výmeru zo zdroja <b>{src.obj} · {src.po} · {src.byt}</b> — <b style={{ color: '#41694C' }}>{f(srcT.spolu)} m²</b>.</div>
        <div style={{ display: 'flex', gap: 10, alignItems: 'center', flexWrap: 'wrap', padding: '11px 14px', background: '#FBFAF7', border: '2px solid #15171A', borderRadius: 11, marginBottom: 14 }}>
          <span style={{ fontWeight: 800, color: '#b45309' }}>Krok späť (poistka):</span>
          <button disabled={busy} onClick={doUndo} style={btn('#15171A', '#fff')}>↩ Vrátiť pôvodnú výmeru ({f(bSum(done.prev).spolu)} m²)</button>
        </div>
        <div style={{ display: 'flex', justifyContent: 'flex-end' }}><button onClick={onClose} style={ghost}>Zavrieť</button></div>
      </div>
    </div></div>
  )

  return (
    <div style={ov} onClick={onClose}><div style={mod} onClick={e => e.stopPropagation()}>
      <div style={head}>Kopírovať výmeru DO bytu</div>
      <div style={body}>
        <div style={srcBox}>
          <div style={{ fontSize: 11, fontWeight: 800, textTransform: 'uppercase', color: '#0369a1' }}>Zdroj (zvolený byt — zafixovaný)</div>
          <div style={{ fontSize: 15, fontWeight: 800, marginTop: 2 }}>{src.obj} · {src.po} · Byt {src.byt}</div>
          <div style={{ fontSize: 13, color: '#5b6573', marginTop: 3 }}>Spolu <b style={{ color: '#41694C' }}>{f(srcT.spolu)} m²</b> · Strop {f(srcT.strop)} · Steny {f(srcT.steny)} · prenesú sa miestnosti + výška + hĺbka</div>
        </div>

        {mode === 'exist' ? <>
          <div style={lab}>① Cieľový byt — vyber zo zoznamu (nemusíš vedieť či „existuje")</div>
          <div style={panel}>
            <div style={{ display: 'flex', gap: 10, alignItems: 'center', flexWrap: 'wrap' }}>
              <label style={{ fontSize: 12, fontWeight: 700, color: '#5b6573' }}>Cieľový byt</label>
              <select value={tgtId} onChange={e => { setTgtId(e.target.value); setConfirmTxt('') }} style={{ ...inp, minWidth: 320 }}>
                {targets.map(b => <option key={b.id} value={b.id}>{(b.obj || '?') + ' · ' + (b.po || '?') + ' · Byt ' + (b.byt || '?') + '  (' + f(bSum(b).spolu) + ' m²)' + (b.completed_at ? ' · uzamknutý' : '')}</option>)}
              </select>
            </div>
            <div style={{ marginTop: 9 }}><span style={lnk} onClick={() => setMode('new')}>Cieľ ešte nie je v zozname? Vytvoriť nový byt ›</span></div>
          </div>

          <div style={lab}>② Potvrdenie (ústava 12.0.3 — prepis ostrých dát)</div>
          <div style={warn}>
            <div style={{ fontWeight: 800, color: '#dc2626', fontSize: 14, marginBottom: 7 }}>NAHRADENIE VÝMERY</div>
            <div style={{ fontSize: 13, lineHeight: 1.5 }}>Byt <b>{tgt ? (tgt.obj + ' · ' + tgt.po + ' · ' + tgt.byt) : '—'}</b> — terajšia výmera (<b style={{ color: '#dc2626' }}>{tgt ? f(bSum(tgt).spolu) : '0,00'} m²</b>) bude <b style={{ color: '#dc2626' }}>NAHRADENÁ</b> výmerou zo zdroja (<b style={{ color: '#41694C' }}>{f(srcT.spolu)} m²</b>). Číslo bytu sa <u>NEMENÍ</u>, mení sa <u>iba výmera</u>.</div>
            <div style={{ fontSize: 13, fontWeight: 700, marginTop: 9 }}>Napíš <b style={{ color: '#dc2626' }}>NAHRADIT</b>:</div>
            <input value={confirmTxt} onChange={e => setConfirmTxt(e.target.value)} placeholder="NAHRADIT" style={cin} />
          </div>
          <div style={{ display: 'flex', gap: 10, justifyContent: 'flex-end', marginTop: 16 }}>
            <button onClick={onClose} style={ghost}>Zrušiť</button>
            <button disabled={!ready || busy} onClick={doReplace} style={btn('#dc2626', '#fff', ready && !busy)}>{busy ? 'Ukladám…' : 'NAHRADIŤ výmeru'}</button>
          </div>
        </> : <>
          <div style={lab}>① Nový byt — predvyplnené z existujúcej štruktúry</div>
          <div style={panel}>
            <div style={{ display: 'flex', gap: 10, alignItems: 'center', flexWrap: 'wrap', marginBottom: 8 }}>
              <label style={{ fontSize: 12, fontWeight: 700, color: '#5b6573' }}>Objekt</label>
              <select value={nObj} onChange={e => { setNObj(e.target.value); setNPo('') }} style={inp}>{objekty.map(o => <option key={o} value={o}>{o}</option>)}</select>
              <label style={{ fontSize: 12, fontWeight: 700, color: '#5b6573' }}>Poschodie</label>
              <input list="po-list" value={nPo} onChange={e => setNPo(e.target.value)} style={{ ...inp, width: 110 }} />
              <datalist id="po-list">{poschodia.map(p => <option key={p} value={p} />)}</datalist>
            </div>
            <div style={{ display: 'flex', gap: 10, alignItems: 'center' }}>
              <label style={{ fontSize: 12, fontWeight: 700, color: '#5b6573' }}>Byt / číslo</label>
              <input value={nByt} onChange={e => setNByt(e.target.value)} placeholder="napr. 7.35" style={{ ...inp, minWidth: 200 }} />
            </div>
            <div style={{ marginTop: 9 }}><span style={{ ...lnk, color: '#5b6573' }} onClick={() => setMode('exist')}>‹ Späť na výber z existujúcich</span></div>
          </div>
          <div style={{ fontSize: 13, padding: '11px 13px', background: '#f3fbf5', border: '1px solid #41694C', borderRadius: 10 }}>
            Vytvorí sa nový byt <b>{nObj} · {nPo} · {nByt || '…'}</b> s výmerou zdroja (<b style={{ color: '#41694C' }}>{f(srcT.spolu)} m²</b>). Nič existujúce sa neprepíše.
          </div>
          <div style={{ display: 'flex', gap: 10, justifyContent: 'flex-end', marginTop: 16 }}>
            <button onClick={onClose} style={ghost}>Zrušiť</button>
            <button disabled={!ready || busy} onClick={doNew} style={btn('#0284c7', '#fff', ready && !busy)}>{busy ? 'Vytváram…' : 'Vytvoriť byt'}</button>
          </div>
        </>}
      </div>
    </div></div>
  )
}
